import { accountTypeWithBorrower, InputType, NewInputTextOptions, NewInputTypeOptions } from 'config'
import { getLoanTypeMapForSelect } from 'reducers/loanDetail.reducer'
import { spanOptions } from 'utils/loanFieldSpan'

export const contractorInputPropertyFields = (): Record<string, InputType> => ({
  visibleAccountTypes: {
    inputType: 'multiselect',
    title: 'Visible by Account Type',
    options: {
      self_creator: '[Loan] Creator',
      ...accountTypeWithBorrower(),
    },
    defaultSelected: true,
    value: {},
    sort: false,
  },
  visibleLoanTypes: {
    inputType: 'multiselect',
    title: 'Visible by Channel',
    options: getLoanTypeMapForSelect(),
    defaultSelected: true,
    value: {},
    sort: false,
  },
  title: {
    inputType: 'text',
    title: 'Title',
    required: false,
    value: '',
  },
  inputType: {
    inputType: 'Select',
    title: 'Input Component Type',
    options: NewInputTypeOptions,
    required: true,
    hasDefaultOption: true,
    visible: false,
  },
  type: {
    inputType: 'select',
    title: 'Input Format',
    options: NewInputTextOptions,
    required: true,
    hasDefaultOption: true,
    allowDefaultOption: true,
    visible: false,
  },
  defaultValue: {
    inputType: 'text',
    title: 'Default Value',
    required: false,
    value: '',
    visible: false,
  },
  options: {
    inputType: 'SelectOptionInput',
    title: 'Select Options',
    value: [],
    required: true,
    visible: false,
  },
  tooltip: {
    inputType: 'textarea',
    title: 'Tooltip',
    rows: 3,
    required: false,
    prefix: '',
    value: '',
  },
  section: {
    inputType: 'select',
    title: 'Section',
    required: false,
    hasDefaultOption: true,
    options: {},
    visible: false,
  },
  visible: {
    inputType: 'ToggleButton',
    title: 'Visible',
    required: true,
  },
  visibleLogic: {
    inputType: 'visibleLogic',
    title: '',
    required: false,
    value: [],
    options: {
      hasNotVisible: true,
    },
  },
  span: {
    inputType: 'select',
    title: 'Span',
    options: spanOptions,
    hasDefaultOption: false,
    value: 1,
    visible: false,
  },
})
